






import React, { useContext, useEffect, useState } from "react";



import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";



function AddressAmendmentOutOfStateLLP() {
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);

  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };

  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_city: '' })

  const [errors, setErrors] = useState({});

  const { services, loading, error } = useContext(ServicesContext);
  // if (loading) {
  //   return <div>Loading...</div>;  // Show loading state while fetching data
  // }

  // if (error) {
  //    return <div>{error}</div> // Show error state if there was an issue fetching data
  // }
  const service = Array.isArray(services) ? services.find(s => s.service_id === 39) : null;

  const validateForm = () => {
    const newErrors = {};

    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }


    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };




  // const formPutPartenshipdeed = async (e) => {
  //   e.preventDefault();

  //   // ✅ Check if user is logged in
  //   // if (!token) {
  //   //   alert("Please log in to continue.");
  //   //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
  //   //   navigate('/login'); // 👈 Use this if you're using React Router
  //   //   return;
  //   // }
  //   if (!validateForm()) return;

  //    localStorage.setItem("bookingData", JSON.stringify(newData));

  //     // Navigate to checkout
  //     navigate('/checkout', {
  //        state: {
  //           service: service,

  //        }
  //     });

  // };

  
        const formPutPartenshipdeed = async (e) => {
          e.preventDefault();
      
          if (!validateForm()) return;
      
          try {
              const response = await PartenerSheepDeedService.addressAmendmentOutOfStateLLP(newData);
      
              console.log("API Success:", response);
      
              navigate("/thankyou");
      
              // Optional: reset form
              setNewData(prev => {
  const resetObj = {};
  Object.keys(prev).forEach(key => (resetObj[key] = ""));
  return resetObj;
});
    
      
          } catch (error) {
              console.error("API Error:", error);
              alert("Something went wrong!");
          }
      };




 const faqList = [
  {
    question: "What is LLP address amendment for out-state LLP?",
    answer: "It is the legal process of changing your LLP’s registered office address from one state to another in India, filed with the Registrar of Companies (RoC)."
  },
  {
    question: "How long does the address amendment process take?",
    answer: "Usually, it takes 15-30 working days depending on the RoC office and the completeness of your documents."
  },
  {
    question: "What documents are required for address amendment?",
    answer: "Key documents include LLP Form 3, proof of the new address (rent agreement or ownership documents), and consent from designated partners."
  },
  {
    question: "Can DM2Legal help with the entire amendment process?",
    answer: "Yes, DM2Legal offers end-to-end services including document preparation, filing, and follow-up with RoC until approval."
  },
  {
    question: "Will the LLP face penalties if the address amendment is delayed?",
    answer: "Yes, delays can lead to fines or compliance issues. It’s important to update your registered address timely."
  },
  {
    question: "Is it mandatory to inform the RoC about the change of LLP address?",
    answer: "Yes, it is a legal requirement to notify the RoC about any change in the registered office address."
  },
  {
    question: "What if the LLP’s partners change during the address amendment?",
    answer: "Any change in designated partners should be separately notified and documented as per LLP regulations."
  },
  {
    question: "How do I contact DM2Legal for LLP address amendment services?",
    answer: "You can contact us via phone, email, or our website contact form to get personalized assistance."
  }
];


const handleBannerClick = () => {
  const formElement = document.querySelector(".contact3-form-all");

  if (formElement) {
    formElement.classList.add("shake-effect");

    // remove effect after animation finishes
    setTimeout(() => {
      formElement.classList.remove("shake-effect");
    }, 400); // same as animation duration
  }
};




  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2 ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>

                <h1 className="sk-text-color">Address Amendment (Out of State) – LLP</h1>

                <p className="pdrl-text">Get LLP Address Amendment (out of State) for only <span className="text-color">Rs.{service?.price}/- </span> <span>(Govt fees and Stamp Duty extra as applicable) </span></p>
                <p className="pd-text">DM2Legal offers a streamlined process for changing your LLP's registered office address to a different state, ensuring compliance with regulatory requirements.</p>

                               <div className="banner" onClick={handleBannerClick}>
   <img src="assets/icons/banner.svg" alt="" />
</div>
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now</h3>         <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Govt fees and Stamp Duty extra as applicable) </span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">


            <div className="col-lg-12">

              {/* <h2>Annual Compliance LLP </h2> */}


              <p className="pd-text">Looking to shift your Limited Liability Partnership (LLP) operations to a different state in India? DM2Legal has got you covered with our comprehensive LLP address amendment service. We understand the complexities involved in amending an LLP's address when moving out of state, and our team of experts is here to assist you every step of the way. Our service includes preparing the necessary documents, such as LLP Form 3 and proof of the new address, ensuring accuracy and compliance. Once the designated partners fill out and sign the form, we handle the submission process to the Registrar of Companies (RoC) in the current registration state. Our professionals liaise with the RoC, ensuring a smooth review and approval process for your address amendment. With DM2Legal by your side, you can rest assured that your LLP's out-of-state address amendment will be handled efficiently and effectively. Contact us today to avail yourself of our reliable and professional service, enabling a seamless transition of your LLP to a new state in India.
              </p>
            </div>

          </div>


        </div>
      </div>



      <div className="service-binifits9 bg-white" >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">How to apply</h2>
                <div className="space20"></div>
                <img src="assets/new/Address-Amendment-out-of-state-(LLP).png" />
              </div>
              <div className="space20"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="space20 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate text-center">Benefits </h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
         <div className="row">
  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon1.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Stay Legally Compliant</a></h4>
        <p className="font-f-7">Keep your registered office address updated to meet legal standards.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon2.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Accurate Official Records</a></h4>
        <p className="font-f-7">Avoid discrepancies by ensuring all documents reflect the correct address.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon3.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Uninterrupted Communication</a></h4>
        <p className="font-f-7">Receive timely notices and correspondences without delays.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon5.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Proper Delivery of Legal Notices</a></h4>
        <p className="font-f-7">Ensure legal notices and summons reach you promptly.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon6.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Uphold Your Good Standing</a></h4>
        <p className="font-f-7">Show commitment to compliance and maintain your company's reputation.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/service6-icon4.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Avoid Penalties</a></h4>
        <p className="font-f-7">Prevent fines by updating your address on time.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/brand6-4.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Ensure Business Continuity</a></h4>
        <p className="font-f-7">Avoid disruptions during audits or transactions with accurate address records.</p>
      </div>
    </div>
  </div>

  <div className="col-lg-4">
    <div className="service6-box s-box">
      <div className="box-img">
        <div className="service-box-icon box-icon">
          <img src="assets/img/icons/work6-icon3.png" alt="" />
        </div>
      </div>
      <div className="hadding6">
        <h4><a href="#" className="font-f-7">Boost Your Professional Image</a></h4>
        <p className="font-f-7">Reflect professionalism with up-to-date and accurate company information.</p>
      </div>
    </div>
  </div>
</div>



          <div className="space20"></div>
        </div>
      </div>

      <div className="service-binifits9 sp0" id="service2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hadding7">
                <div className="space80"></div>
                <h2>Online Registration Procedure </h2>
              </div>
              <div className="partnership-deade-section">
                <div className="space40"></div>

                <ul className="disc-list">
                  <li>
                    <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Provide your current LLP information and the new registered address.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Our team fills out LLP Form 3 and compiles the necessary digital documents.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Designated partners review and e-sign the documents electronically.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>We file the application and documents online with the Registrar of Companies (RoC).</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li>
                    <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                    <span>We'll share confirmation once your new registered office address is officially approved.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                </ul>

                <div className="space80"></div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="bg-white">

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                    <div className="space30"></div>
                    <div id="general">


                      {faqList.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                  <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                  <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                  <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                  <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                  <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      < WhatsAppScrollButton />

      <Footer />
      <CircularScrollProgress />
    </div>

  );
}
export default AddressAmendmentOutOfStateLLP;

